'use client';
import { FC, useState } from 'react';

import { useTranslation, useWindowDimensions } from '@/hook';
import Typography from '@/components/shared/typography/typography.component';
import { AddressSrc, ILocation } from '@/types';
import { X } from '../../../../public/Images';
import Map from './google-map.component';

import Image from 'next/image';
const MapComponent: FC<{
    setLocation: (location: ILocation) => void;
    location: ILocation;
    setLocationOpen: (open: boolean) => void;
    addressSrc: AddressSrc;
    setAddressSrc: (src: AddressSrc) => void;
}> = ({
    setLocation,
    location,
    setLocationOpen,
    addressSrc,
    setAddressSrc,
}) => {
    const { width } = useWindowDimensions();
    const IS_DESKTOP = width >= 1100;
    const { t } = useTranslation();
    const [currLoc, setCurrLoc] = useState<ILocation>(location);

    const handleConfirmLocation = () => {
        setLocation(currLoc);
    };
    const setLoc = (loc: ILocation) => {
        setCurrLoc(loc);
    };

    return (
        <div
            style={{
                height: '80vh',
                width: IS_DESKTOP ? '50vw' : '100%',
                padding: IS_DESKTOP ? '24px' : '',
                paddingBottom: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography variant="subtitle1">
                    {t('selectInspectionLocation')}
                </Typography>
                <Image
                    src={X.src}
                    width={X.width}
                    height={X.height}
                    onClick={() => setLocationOpen(false)}
                    style={{ cursor: 'pointer' }}
                    alt="close"
                />
            </div>
            <Map
                onSetLocation={setLoc}
                location={currLoc}
                addressSrc={addressSrc}
                setAddressSrc={setAddressSrc}
            />
            <div>
                <Typography variant="body2Medium" style={{ display: 'inline' }}>
                    {t('address')}
                    {': '}
                </Typography>
                <Typography variant="body2" style={{ display: 'inline' }}>
                    {currLoc.address}
                </Typography>

                <button
                    style={{ height: '48px' }}
                    disabled={!(currLoc?.address || location.address)}
                    onClick={handleConfirmLocation}
                    className="sylndr_button primary"
                >
                    <Typography>{t('confirmInspectionLocation')}</Typography>
                </button>
            </div>
        </div>
    );
};

export default MapComponent;
